import React, { FC} from 'react'
import { useSelector } from 'react-redux'
import { Helmet } from 'react-helmet'
import { useLocation } from 'react-router-dom'
import urlJoin from 'url-join'
import { BASE_URL, WEB_SITE_NAME, STATIC_PATH, SEO_DEFAULT_IMAGE } from 'src/common/razzle-platform-components/configs'
import { toLanguageTerritoryFormat } from 'src/common/razzle-platform-translate/utils'

type SEOEnhancerProps = {
    title: string
    description: string
    // image will be display when we share the page
    imageUrl?: string
}


/**
 * we use this component to generate and inject seo tags in the head of the page
 * @param props SEOEnhancerProps
 */
export const SEOEnhancer : FC<SEOEnhancerProps> = (props) => {
    const location = useLocation()
    const locale = useSelector((state: any) => state.translationModel.locale)

    const currentPageUrl = urlJoin(BASE_URL, location.pathname)
    const imageUrl = props.imageUrl ? props.imageUrl : urlJoin(STATIC_PATH, `assets/images/${SEO_DEFAULT_IMAGE}`)

    return (
        <Helmet>
            <title>{props.title}</title>
            <meta name="description" content={props.description} />
            <link rel="canonical" href={currentPageUrl} />
            <meta name="robots" content="index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1" />
            {/* facebook tags */}
            <meta property="og:url" content={currentPageUrl} />
            <meta property="og:title" content={props.title} />
            <meta property="og:description" content={props.description} />
            <meta property="og:type" content="website" />
            <meta property="og:image" content={imageUrl} />
            <meta property="og:image:width" content="500" />
            <meta property="og:image:height" content="500" />
            <meta property="og:image:alt" content={props.title} />
            <meta property="og:site_name" content={WEB_SITE_NAME} />
            <meta property="og:locale" content={toLanguageTerritoryFormat(locale)} />
            {/* twitter tags */}
            <meta name="twitter:url" content={currentPageUrl} />
            <meta name="twitter:title" content={props.title} />
            <meta name="twitter:description" content={props.description} />
            <meta name="twitter:image" content={imageUrl} />
            <meta name="twitter:domain" content={WEB_SITE_NAME} />
            <meta name="twitter:card" content="summary_large_image" />
            {/* extra tags */}
            { props.children }

        </Helmet>
    )
}
